import { TreatmentArea } from '../types';

export const TREATMENT_AREAS: TreatmentArea[] = [
  {
    id: 'sakal-ustu-boyun',
    name: 'Sakal Üstü, Yanak & Boyun / Ense',
    category: 'face',
    shortDesc: 'Tıraş sonrası oluşan kıl dönmesi, batık ve tahrişi tamamen bitirir. Net ve keskin sakal hattı sağlar.',
    longDesc: 'Erkeklerde en sık tercih edilen uygulamadır. Yanak üstündeki dağınık tüyler ve boyun bölgesindeki tıraş tahrişleri medikal buz lazer ile kalıcı olarak temizlenir. Sakalın doğal şekli korunarak sadece istenmeyen kısımlar alınır.',
    durationMinutes: 10,
    recommendedSessions: '6 - 8 Seans',
    painLevel: 1,
    popularFor: 'Net sakal çizgisi ve sıfır tıraş batığı isteyen iş insanları ve profesyoneller',
    benefits: [
      'Her sabah yanak ve boyun tıraşı zorunluluğunu ortadan kaldırır',
      'Kıl dönmesi (Folikülit) ve sivilce oluşumunu engeller',
      'Net, berber tıraşı kalitesinde kalıcı sakal çizgisi oluşturur',
      'Erkek kıl yapısına özel dalga boyuyla hızlı sonuç'
    ],
    preparationTip: 'İşlemden 24 saat önce sakal sınırlarınızı istediğiniz gibi jiletle düzeltiniz.',
    iconName: 'Sparkles'
  },
  {
    id: 'sirt-omuz',
    name: 'Sırt & Omuz Bölgesi',
    category: 'upper',
    shortDesc: 'Erkeklerde en derin köklere sahip bölgedir. Buz başlıklı hibrit sistemle konforlu ve homojen temizlik.',
    longDesc: 'Sırt ve omuz bölgesindeki kıl kökleri derin yerleşimlidir. Doktor kontrolündeki cihazımızın yüksek enerjili soğutma teknolojisi sayesinde cilt yüzeyi korunurken kıl kökü kalıcı olarak inaktif hale getirilir.',
    durationMinutes: 20,
    recommendedSessions: '6 - 8 Seans',
    painLevel: 2,
    popularFor: 'Yazın plajda veya sporda pürüzsüz ve rahat hissetmek isteyen erkekler',
    benefits: [
      'Geniş başlık taramasıyla hızlı ve homojen dökülme',
      'Terleme ve koku oluşumunda belirgin azalma',
      'Sırt sivilceleri ve batıkların tedavisine katkı',
      'Görünmeyen bölgelerde sıfır leke ve yanık riski'
    ],
    preparationTip: 'İşlemden 1 gün önce jilet veya tıraş makinesiyle kısaltılması yeterlidir.',
    iconName: 'Shield'
  },
  {
    id: 'gogus-karin',
    name: 'Göğüs & Karın Bölgesi',
    category: 'upper',
    shortDesc: 'İster tamamen sıfırlama, ister doğal seyreltme seçeneği. Sporcular ve konfor arayanlar için ideal.',
    longDesc: 'Göğüs ve karın bölgesinde yoğun kıl yapısından rahatsız olan erkekler için kişiselleştirilmiş program uygulanır. Kılların tamamını bitirmek veya sadece %70-80 oranında seyrelterek doğal bir görünüm elde etmek mümkündür.',
    durationMinutes: 15,
    recommendedSessions: '6 - 8 Seans',
    painLevel: 2,
    popularFor: 'Fitness, yüzme ve vücut geliştirme ile ilgilenen sporcular',
    benefits: [
      'İsteğe bağlı tam pürüzsüzlük veya estetik seyreltme',
      'Spor sonrası ter birikimini ve tahrişi engelleme',
      'Kas hatlarının belirginliğini öne çıkarma',
      'Gömlek altından çıkan tüyleri kalıcı olarak yok etme'
    ],
    preparationTip: 'İşlemden 24 saat önce tıraş edilmesi önerilir. Güneşlenmiş ciltler için hekimimiz dozaj ayarı yapar.',
    iconName: 'Flame'
  },
  {
    id: 'koltuk-alti',
    name: 'Koltuk Altı',
    category: 'arms',
    shortDesc: 'Kişisel hijyen, ter kokusu kontrolü ve konfor için en hızlı sonuç veren bölge (ortalama 5-10 dk).',
    longDesc: 'Koltuk altı bölgesi erkeklerde kıl köklerinin lazere en hızlı ve güçlü yanıt verdiği alandır. Sadece birkaç seansta kılların büyük kısmı dökülür ve ter kokusu önemli ölçüde azalır.',
    durationMinutes: 5,
    recommendedSessions: '5 - 6 Seans',
    painLevel: 1,
    popularFor: 'Günlük hijyen ve ter kokusunu azaltmak isteyen tüm erkekler',
    benefits: [
      'Bakteri birikimini önleyerek ter kokusunu %70 azaltır',
      'Kısa süreli işlem (seans başı sadece 5 dakika)',
      'Hızlı ve kalıcı dökülme oranı',
      'Koyu ten ve sert kıl yapısında dahi yüksek başarı'
    ],
    preparationTip: 'Seans günü deodorant veya roll-on kullanmadan geliniz.',
    iconName: 'Zap'
  },
  {
    id: 'kollar-eller',
    name: 'Tüm Kol & El Üstü',
    category: 'arms',
    shortDesc: 'Kol ve parmak üzerindeki aşırı kıllanmayı düzenler; seyreltme veya tam bitirme opsiyonu.',
    longDesc: 'Özellikle saat veya takı takan, kısa kollu giyindiğinde kollarındaki aşırı yoğunluktan rahatsız olan erkekler için kademeli ve homojen bir sonuç sağlar.',
    durationMinutes: 15,
    recommendedSessions: '6 - 8 Seans',
    painLevel: 1,
    popularFor: 'Dövmeli veya dövmesiz kollarda temiz ve estetik görünüm arayanlar',
    benefits: [
      'El üstü ve parmak kıllarında kalıcı temizlik',
      'Doğal seyreltme seçeneğiyle yapay durmayan görünüm',
      'Yaz aylarında ferahlık ve hijyen',
      'Dövme olan bölgelerin etrafında hassas koruma protokolü'
    ],
    preparationTip: 'Dövmeniz varsa uzmanımıza mutlaka belirtiniz.',
    iconName: 'Activity'
  },
  {
    id: 'bacak-tum',
    name: 'Tüm Bacak & Ayak Üstü',
    category: 'lower',
    shortDesc: 'Bisikletçiler, koşucular ve kıl dönmesi yaşayanlar için ferahlatıcı medikal epilasyon.',
    longDesc: 'Yoğun bacak kılları pantolon sürtünmesiyle batık ve iltihaplanmaya yol açabilir. Medikal lazer seanslarıyla bacak cildi pürüzsüzleşir ve batık sorunları ortadan kalkar.',
    durationMinutes: 25,
    recommendedSessions: '6 - 8 Seans',
    painLevel: 2,
    popularFor: 'Sporcular, bisikletçiler ve sürekli batık problemi yaşayanlar',
    benefits: [
      'Spor performansında ve masaj uygulamasında kolaylık',
      'Pantolon sürtünmesinden kaynaklanan batık ve kaşıntıya son',
      'Yazın şort kullanımında özgüven ve rahatlık',
      'Geniş soğutmalı başlık ile acısız seans deneyimi'
    ],
    preparationTip: 'Seans öncesinde kuru cilde nemlendirici sürmeyiniz, tıraşı 1 gün önce yapınız.',
    iconName: 'Compass'
  },
  {
    id: 'ozel-bolge-genital',
    name: 'Bursa Erkek Özel Bölge Lazer Epilasyon (Genital & Kasık)',
    category: 'lower',
    shortDesc: 'Maksimum kişisel hijyen, sporcu konforu ve %100 mahremiyet standartlarında erkek uzman kontrolünde acısız seans.',
    longDesc: 'Bursa Erkek Özel Bölge Lazer Epilasyonu; kasık, genital ve perianal bölgede oluşan kıl dönmesi, batık, terleme, koku ve sürtünme tahrişini kalıcı olarak sonlandıran medikal bir uygulamadır. FSM Bulvarı Nilüfer kliniğimizde erkek uzman güvencesi, kişiye özel tek kullanımlık hijyen örtüleri ve -5°C buz başlık teknolojisi ile sıfıra yakın acı ve tam gizlilik esasıyla sunulmaktadır.',
    durationMinutes: 15,
    recommendedSessions: '6 - 8 Seans',
    painLevel: 1,
    popularFor: 'Kişisel hijyenine önem verenler, sporcular ve pişik/kıl dönmesi sorununu kökten çözmek isteyen erkekler',
    benefits: [
      '%100 Mahremiyet: Yalnızca erkek uzman kontrolünde, steril ve kişiye özel seans odası',
      'Terleme, pişik, koku ve batık (kıl dönmesi) problemlerinde kalıcı çözüm',
      'Üreme sağlığına ve iç organlara sıfır etki (FDA onaylı, yalnızca 2-4 mm kıl köküne odaklı teknoloji)',
      '-5°C temas soğutmalı safir buz başlık ile konforlu, acısız ve hızlı uygulama'
    ],
    preparationTip: 'Seansınızdan 24 saat önce jiletle nazikçe kısaltınız. Ağda, cımbız veya tüy dökücü kimyasallar kullanmayınız.',
    iconName: 'Shield'
  },
  {
    id: 'ense-kulak-burun',
    name: 'Ense, Kulak & Burun Üstü',
    category: 'face',
    shortDesc: 'Sürekli berberde çakmak/ağda yaptırma devrini bitiren kalıcı mikro detay temizliği.',
    longDesc: 'Kulak içi ve kenarı ile burun üstü ve ense kılları için özel tasarlanmış mikro başlık adaptörüyle hassas ve acısız lazer atışı yapılır.',
    durationMinutes: 5,
    recommendedSessions: '5 - 7 Seans',
    painLevel: 1,
    popularFor: 'Berberde yakma ve cımbız acısından kurtulmak isteyenler',
    benefits: [
      'Ağrılı cımbız ve ağda uygulamalarına son',
      'Gömlek yakasından taşan ense kıllarını kalıcı olarak sıfırlama',
      'Kulak ve burun bölgesinde steril medikal uygulama',
      'Seans süresi sadece 5 dakika'
    ],
    preparationTip: 'Kulak ve burun kıllarını seans öncesi cımbızla çekmeyiniz.',
    iconName: 'CheckCircle2'
  },
  {
    id: 'full-body-package',
    name: 'Erkek Full Paket (Sırt + Göğüs + Koltuk Altı + Sakal Üstü)',
    category: 'packages',
    shortDesc: 'En çok tercih edilen 4 ana bölge kombini. Tek seansta kesintisiz ve hızlı tarama.',
    longDesc: 'Erkeklerin en çok şikayetçi olduğu 4 ana bölgeyi tek bir avantajlı seans paketinde birleştiriyoruz. Safir buz başlıklı kesintisiz in-motion tarama sayesinde seans yalnızca 45 dakikada biter.',
    durationMinutes: 45,
    recommendedSessions: '6 - 8 Seans',
    painLevel: 2,
    popularFor: 'Tüm vücutta tek seferde köklü ve kalıcı temizlik arayan erkekler',
    benefits: [
      'Tekil bölgelere göre %35 daha avantajlı kombine paket',
      'Kesintisiz in-motion buz başlık ile seans süresi sadece ~45 dakika',
      'Doktor gözetiminde kişiye özel seans planlaması',
      'Seans aralarında ücretsiz kontrol ve atış hakkı'
    ],
    preparationTip: 'Tüm bölgeler randevudan 1 gün önce jiletle kısaltılmalıdır.',
    iconName: 'Award'
  },
  {
    id: 'complete-body-package',
    name: 'Tepeden Tırnağa Komple Paket (Tüm Vücut)',
    category: 'packages',
    shortDesc: 'Tüm vücut bölgelerinin (Sırt, Göğüs, Kol, Bacak, Sakal, Koltuk Altı) tek seansta hızlı taraması.',
    longDesc: 'Modern 3 dalga boylu hibrit buz lazer sistemi sayesinde tüm vücut uygulaması seanslar arası bekleme olmadan, tek seansta yaklaşık 60 dakikada konforla tamamlanır.',
    durationMinutes: 60,
    recommendedSessions: '6 - 8 Seans',
    painLevel: 2,
    popularFor: 'Tüm vücudunda eksiksiz hijyen ve estetik pürüzsüzlük isteyenler',
    benefits: [
      'Maksimum paket indirimi ve seans takibi',
      'Tüm vücut tek seansta yalnızca ~60 dakika',
      'Acısız safir temas soğutması (-5°C)',
      'Doktor klinik güvencesi'
    ],
    preparationTip: 'Tüm vücut bölgeleri işlemden 24 saat önce tıraş edilmelidir.',
    iconName: 'Flame'
  }
];
